import Lottie from "lottie-react";
import loadingAnimation from "../../../../../animations/loading.json";
import styled from "styled-components";
import { Flex } from "rebass/styled-components";

export const Loading = () => {
  return (
    <>
      <LoadingWrapper
        justifyContent={"center"}
        alignItems={"center"}
        data-testid="loading-wrapper"
      >
        <Lottie
          animationData={loadingAnimation}
          style={{ height: 100, width: 100 }}
          loop={true}
        />
      </LoadingWrapper>
    </>
  );
};

const LoadingWrapper = styled(Flex)`
  align-items: center;
  height: 100% !important;
  justify-content: center;
  width: 100% !important;
`;
